import { ItemDataTypes, ItemType } from 'store/types'
import { useAtom } from 'jotai'
import { canvaPropsAtom, higherZIndexAtom, itemsDataAtom, selectedItemIdAtom } from 'store/atoms'
import { useCallback, useState } from 'react'
import ImageIcon from 'atoms/icons/ImageIcon'
import TextIcon from 'atoms/icons/TextIcon'
import { createImage, createShape, createText } from 'store/factory'
import ColorPickerButton from 'molecules/ColorPickerButton'
import ColorBucketIcon from 'atoms/icons/ColorBucketIcon'
import FireIcon from 'atoms/icons/FireIcon'
import DeletePostModal from 'molecules/DeletePostModal'
import { RESET } from 'jotai/utils'
import ShapesIcon from 'atoms/icons/ShapesIcon'

function PostAddItemTools() {
  const [canvaProps, setCanvaProps] = useAtom(canvaPropsAtom)
  const [_, setItemsData] = useAtom(itemsDataAtom)
  const [__, setSelectedItemId] = useAtom(selectedItemIdAtom)
  const [higherZIndex, setHigherZIndex] = useAtom(higherZIndexAtom)

  const [deletePostModalOpen, setDeletePostModalOpen] = useState(false)

  const createItem = useCallback(
    (type: ItemType) => {
      let item: ItemDataTypes
      switch (type) {
        case 'text':
          item = createText()
          break
        case 'image':
          item = createImage()
          break
        case 'shape':
          item = createShape()
          break
      }
      const index = higherZIndex + 1
      item.zIndex = index
      setItemsData(oldState => ({
        ...oldState,
        [item.id]: item
      }))
      setHigherZIndex(index)
      setSelectedItemId(item.id)
    },
    [higherZIndex]
  )

  return (
    <>
      <div className='col-span-2 card bg-gray-100'>
        <div className='card-body p-4'>
          <div className='divider'>Quadro</div>
          <div className='flex flex-col gap-2'>
            <div className='flex flex-row flex-wrap gap-2'>
              <ColorPickerButton
                leftElement={<ColorBucketIcon size={18} />}
                color={canvaProps.backgroundColor}
                onChangeColor={backgroundColor =>
                  setCanvaProps(oldState => ({
                    ...oldState,
                    backgroundColor
                  }))
                }
              />
            </div>
          </div>

          <div className='divider'>Adicionar</div>
          <div className='flex gap-2'>
            <button className='flex-1 btn btn-primary btn-outline' onClick={() => createItem('text')}>
              <TextIcon />
              Texto
            </button>
            <button className='flex-1 btn btn-primary btn-outline' onClick={() => createItem('image')}>
              <ImageIcon />
              Imagem
            </button>
            <button className='flex-1 btn btn-primary btn-outline' onClick={() => createItem('shape')}>
              <ShapesIcon />
              Formas
            </button>
          </div>

          <div className='divider' />
          <div className='flex gap-2'>
            <button className='flex-1 btn btn-error' onClick={() => setDeletePostModalOpen(true)}>
              <FireIcon />
              Limpar tudo
            </button>
          </div>
        </div>
      </div>
      <DeletePostModal
        open={deletePostModalOpen}
        onClose={() => setDeletePostModalOpen(false)}
        onConfirm={() => {
          setDeletePostModalOpen(false)
          setItemsData(RESET)
          setCanvaProps(RESET)
          setSelectedItemId(undefined)
        }}
      />
    </>
  )
}

export default PostAddItemTools
